module.exports = __webpack_public_path__ + "static/media/addfeedback.6a152508.PNG";